var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.372,
    height: 69.632,
    viewBox: "0 0 62.372 69.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_1_",
    "data-name": "stopwatch (1)",
    d: "M88.266,15.365,80.958,8.057A2.72,2.72,0,0,0,77.111,11.9l1.731,1.731-3.55,3.55A29.367,29.367,0,0,0,59.059,10.46V5.44h2.448a2.72,2.72,0,0,0,0-5.44H51.171a2.72,2.72,0,1,0,0,5.44h2.448v5.02a29.647,29.647,0,1,0,25.52,10.571l3.55-3.55,1.731,1.731a2.72,2.72,0,1,0,3.847-3.847ZM56.339,64.192A24.208,24.208,0,1,1,80.547,39.984,24.235,24.235,0,0,1,56.339,64.192ZM70.472,39.984a2.72,2.72,0,0,1-2.72,2.72H56.339a2.72,2.72,0,0,1-2.72-2.72v-16a2.72,2.72,0,1,1,5.44,0V37.264h8.693A2.72,2.72,0,0,1,70.472,39.984Z",
    transform: "translate(-26.691)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.b2f22339.svg";
export { ForwardRef as ReactComponent };